export enum ApNutrientGroup {
  Organic = 1,
  Mineral = 2
}
